import type { Prisma } from "@prisma/client";

import { DocumentType, IssuerType } from "./file-data.internal.vars";

export const documentTypes = [
  "KBIS",
  "PIECE_IDENTITE",
  "PLANS",
  "DECLARATION_OUVERTURE_CHANTIER",
  "ATTESTATION_DEMARRAGE",
  "PERMIS_CONSTRUIRE",
  "DECLARATION_PREALABLE",
  "PLANNING_TRAVAUX",
  "DECLARATION_ACHEVEMENT_TRAVAUX",
  "CONVENTION_HONORAIRES",
  "ATTESTATION_DECENNALE",
  "FACTURE",
  "RAPPORT_ETUDE_TECHNIQUE",
  "RAPPORT_GEOTECHNIQUE",
  "RAPPORT_INITIAL_CONTROLE_TECHNIQUE",
  "RAPPORT_FINAL_CONTROLE_TECHNIQUE",
  "DEVIS",
  "PV_RECEPTION",
  "LEVEE_RESERVES_PV_RECEPTION",
  "REFERE_PREVENTIF_POUR_AVOISINANTS",
  "CONSTAT_HUISSIER_POUR_EXISTANTS",
  "CONTRAT_RESERVATION_BAILLEUR_SOCIAL",
  "INDICATION_TARIFAIRE",
  'NOTICE_DESCRIPTIVE',
  "OTHER",
] as const;

export const gfaDocumentTypes = [
   "PRESENTATION_HISTORIQUE_SOCIETE",
		 "KBIS",
		 "STATUTS",
		 "DERNIER_BILAN_PROMOTEUR",
		 "DERNIER_BILAN_ACTIONNAIRES",
		 "DERNIER_BILAN_CONSOLIDE_GROUPE",
		 "CV_DIRIGEANTS",
		 "COPIE_CNI_DIRIGEANT",
		 "ORGANIGRAMME",
     "PRESENTATION_HISTORIQUE_SOCIETE_DERNIERES_OPERATIONS",
		 "LISTE_OPERATIONS_EN_COURS",
		 "FICHE_PATRIMONIALE_DIRIGEANTS",
		 "ATTESTATION_NOTARIEE_PROPRIETE_FONCIERE",
		 "CONTRAT_RESERVATION_TYPE",
		 "CALENDRIER_APPEL_DE_FONDS",
     "ATTESTATION_NOTARIEE_PRE_CO",
		 "GRILLE_LOTS",
		 "BILAN_FINANCIER_OPERATION",
		 "PREVISIONNEL_TRESORERIE",
		 "JUSTIFICATIF_APPORTS_FONDS_PROPRES",
		 "ACCORD_FINANCEMENT",
		 "DEBOURSE_TRAVAUX_CORPS_ETAT",
		 "RIB_COMPTE_CENTRALISEUR",
		 "ARRETES_PERMIS_CONSTRUIRE",
		 "PV_CONSTAT_AFFICHAGE",
		 "ATTESTATION_NON_RECOURS",
		 "NOTICE_DESCRIPTIVE",
		 "PLANS_PC",
		 "PLANNING_PREVISIONNEL",
		 "DECLARATION_OUVERTURE_CHANTIER",
		 "CONTRAT_MOE_ATTESTATION_RDC",
		 "CONVENTION_CONTROLE_TECHNIQUE",
		 "RICT",
		 "ETUDE_DE_SOL",
		 "DESCRIPTIF_TRAVAUX_CHIFFRES",
		 "ATTESTATION_DO_TRC_CNR_RCMO",
		 "LISTE_ENTREPRISES_SIREN",
		 "DEVIS_OU_MARCHES_SIGNES",
     "OTHER_PROMOTER_DOCUMENT",
     "OTHER_LEGAL_AND_COMMERCIAL_DOCUMENT",
     "OTHER_FINANCIAL_DOCUMENT",
     "OTHER_TECHNICAL_DOCUMENT",
		 "OTHER"
] as const;

export const reportTypes = [
  "INITIAL",
  "FINAL",
] as const;

export const issuerTypes = [
  "ARCHITECTE",
  "BUREAU_ETUDE",
  "CONTROLEUR_TECHNIQUE",
  "GENERALITES",
  "GEOTECHNICIEN",
  "MATERIAUX",
  "MAITRE_OEUVRE",
  "REALISATEUR",
] as const;

export const architecteMissions = [
  "Conception",
  "Dépôt d'autorisation administrative",
  "Suivi des travaux",
] as const;

export const maitreOeuvreMissions = [
  "Conception",
  "Dépôt d'autorisation administrative",
  "Suivi des travaux",
] as const;

export const bureauEtudeMissions = [
  "Structurelles",
  "Acoustiques",
  "Assainissement",
  "Infiltration",
  "Géotechniques",
  "Thermiques",
  "Fluides",
  "VRD (Voirie et Réseaux Divers)",
  "HQE/Développement durable",
  "Eclairage",
  "Sécurité incendie"
] as const;

export const geotechnicienMissions = [
  "G1",
  "G2AVP",
  "G2PRO",
  "G3",
  "G4",
  "G5"
] as const;

export const controleurTechniqueMissions = [
  "L : Solidité des ouvrages constitutifs ou indissociables au bâtiment",
  "LP : Solidité des ouvrages indissociables et dissociables",
  "LE : Solidité des existants",
  "AV : vérification des Avoisinants",
  "PS : Sécurité des personnes dans les constructions en cas de Séisme",
  "S : Sécurité des personnes dans la construction",
  "SH : Sécurité incendie des personnes dans les bâtiments d'habitation",
  "STI : Sécurité incendie des personnes dans les bâtiments relevant du code du travail uniquement",
  "SEI : Sécurité incendie des personnes dans les établissements recevant du public",
  "HAND : Vérification des exigences d'accessibilité des personnes handicapées",
  "BRD : Passage du brancard",
  "Th : Vérification des exigences d'isolation thermique et aux économies d'énergie des bâtiments",
  "PHh : Vérification des exigences d'isolation acoustique dans les bâtiments d'habitation",
  "PHa : Vérification des exigences d'isolation acoustique dans les bâtiments autre qu'habitation",
  "PV : Recollement des procès-verbaux d'essais de fonctionnement des installations",
  "F : Fonctionnement des installations"
] as const;

export const builderMainActivities = [
  "Terrassement",
  "Amélioration des sols",
  "Voiries Réseaux Divers (V.R.D)",
  "Démolition sans utilisation d'explosifs",
  "Démolition avec utilisation d'explosifs",
  "Forage vertical",
  "Aménagements paysagers",
  "Montage d'échafaudage - Etaiement",
  "Traitement amiante",
  "Traitement contre les insectes xylophages et les champignons",
  "Assèchement des murs",
  "Fondations et parois spéciales",
  "Maçonnerie et béton armé",
  "Charpente et structure de bois",
  "Béton précontraint in situ",
  "Constructions à ossature bois",
  "Charpente et structure métallique",
  "Couverture",
  "Etanchéité de toiture, terrasse et plancher intérieur",
  "Revêtements de façades par enduits, avec ou sans fonction d'imperméabilité et/ou d'étanchéité, ravalements",
  "Bardages de façade",
  "Menuiseries extérieures",
  "Etanchéité et imperméabilisation de cuvelage, réservoirs et piscines",
  "Isolation thermique par l'extérieur",
  "Façades-Rideaux",
  "Structures et couvertures textiles",
  "Verrières - Vérandas",
  "Menuiseries intérieures",
  "Plâtrerie – Staff – Stuc – Gypserie",
  "Serrurerie – Métallerie",
  "Peinture",
  "Revêtement intérieur de surfaces en matériaux souples et parquets",
  "Aménagement de salles de bains domestiques",
  "Aménagement de cuisines domestiques",
  "Revêtement de surfaces en matériaux durs – Chapes et sols coulés",
  "Revêtement vertical en matériaux durs agrafés ou attachés",
  "Isolation intérieure thermique – Acoustique",
  "Isolation frigorifique",
  "Plomberie",
  "Chauffages et installations thermiques",
  "Electricité",
  "Fumisterie",
  "Installations d'aéraulique, de climatisation et de conditionnement d'air",
  "Ascenseurs",
  "Piscines",
  "Géothermie",
  "Photovoltaïque",
  "Eolien",
  "Four et cheminée industriels"
] as const;

export const metadataMultiselectOptions = [
  ...architecteMissions,
  ...bureauEtudeMissions,
  ...controleurTechniqueMissions,
  ...geotechnicienMissions,
  ...builderMainActivities,
] as const;

export const decennialCertificateMetadataFields = {
  validityStartDate: true,
  validityEndDate: true,
  activities: true,
  additionalActivities: true,
  excludedActivities: true,
  insurerSociety: {
    select: {
      society: {
        select: {
          siren: true,
        },
      },
    },
  },
} satisfies Prisma.DecennialCertificateSelect;

export const devisRealisateurFileMetadataDetailsSelector = {
  id: true,
  fileData: {
    select: {
      type: true,
      issuer: true,
    },
  },
  constructionSiteSubmissions: {
    select: {
      participant: {
        select: {
          society: {
            select: {
              siren: true,
              denomination: true,
            },
          },
        },
      },
      quoteOrFeeAgreementDetails: {
        select: {
          moaFirstName: true,
          moaLastName: true,
          missionsOrActivitiesOrMaterialTypes: true,
          feesHT: true,
          feesTTC: true
        },
      }
    }
  }
} satisfies Prisma.FileSelect;

export const devisMateriauxFileMetadataDetailsSelector = {
  id: true,
  fileData: {
    select: {
      type: true,
      issuer: true,
    },
  },
  constructionSiteSubmissions: {
    select: {
      participant: {
        select: {
          society: {
            select: {
              siren: true,
              denomination: true,
            },
          },
        },
      },
      quoteOrFeeAgreementDetails: {
        select: {
          moaFirstName: true,
          moaLastName: true,
          date: true,
          missionsOrActivitiesOrMaterialTypes: true,
          feesHT: true,
          feesTTC: true
        },
      }
    }
  }
} satisfies Prisma.FileSelect;

export const attestationDecennaleGeotechnicienFileMetadataDetailsSelector = {
  id: true,
  fileData: {
    select: {
      type: true,
      issuer: true,
    },
  },
  decennialCertificate: {
    select: {
      validityStartDate: true,
      validityEndDate: true,
      activities: true,
      insurerSociety: {
        select: {
          society: {
            select: {
              siren: true,
            },
          },
        },
      },
      Participant: {
        select: {
          society: {
            select: {
              siren: true,
              denomination: true,
            },
          },
        },
      },
    },
  },
} satisfies Prisma.FileSelect;

export const conventionHonorairesArchitecteFileMetadataDetailsSelector = {
  id: true,
  fileData: {
    select: {
      type: true,
      issuer: true,
    },
  },
  constructionSiteSubmissions: {
    select: {
      participant: {
        select: {
          society: {
            select: {
              siren: true,
              denomination: true,
            },
          },
        },
      },
      quoteOrFeeAgreementDetails: {
        select: {
          moaFirstName: true,
          moaLastName: true,
          missionsOrActivitiesOrMaterialTypes: true,
          feesHT: true,
          feesTTC: true
        },
      }
    }
  }
} satisfies Prisma.FileSelect;

export const attestationDecennaleRealisateurFileMetadataDetailsSelector = {
  id: true,
  fileData: { select: { type: true, issuer: true } },
  decennialCertificate: {
    select: {
      validityStartDate: true,
      validityEndDate: true,
      activities: true,
      insurerSociety: { select: { society: { select: { siren: true } } } },
      Participant: { select: { society: { select: { siren: true, denomination: true } } } },
    },
  },
} satisfies Prisma.FileSelect;

export const attestationDecennaleArchitecteFileMetadataDetailsSelector = {
  id: true,
  fileData: { select: { type: true, issuer: true } },
  decennialCertificate: {
    select: {
      validityStartDate: true,
      validityEndDate: true,
      activities: true,
      insurerSociety: { select: { society: { select: { siren: true } } } },
      Participant: { select: { society: { select: { siren: true, denomination: true } } } },
    },
  },
} satisfies Prisma.FileSelect;

export const rapportEtudeTechniqueArchitecteFileMetadataDetailsSelector = {
  id: true,
  fileData: { select: { type: true, issuer: true } },
  constructionSiteSubmissions: {
    select: {
      participant: {
        select: {
          society: {
            select: {
              siren: true,
              denomination: true,
            },
          },
        },
      },
      reportDetails: {
        select: {
          reportDate: true,
          conclusion: true,
        },
      }
    }
  }
} satisfies Prisma.FileSelect;

export const rapportGeotechniqueGeotechnicienFileMetadataDetailsSelector = {
  id: true,
  fileData: { select: { type: true, issuer: true } },
  constructionSiteSubmissions: {
    select: {
      reportDetails: {
        select: {
          reportDate: true,
          missions: true,
          conclusion: true,
        },
      },
      participant: {
        select: {
          society: {
            select: {
              siren: true,
              denomination: true,
            },
          },
        },
      },
    },
  },
} satisfies Prisma.FileSelect;

export const rapportInitialControleTechniqueFileMetadataDetailsSelector = {
  id: true,
  fileData: { select: { type: true, issuer: true } },
  constructionSiteSubmissions: {
    select: {
      participant: {
        select: {
          society: {
            select: {
              siren: true,
              denomination: true,
            },
          },
        },
      },
      reportDetails: {
        select: {
          reportDate: true,
          unfavourableOpinionCount: true,
          unfavourableOpinionDescription: true,
          suspendedOpinionCount: true,
          suspendedOpinionDescription: true,
          missions: true,
          conclusion: true,
        },
      }
    }
  }
} satisfies Prisma.FileSelect;

export const factureMateriauxFileMetadataDetailsSelector = {
  id: true,
  fileData: { select: { type: true, issuer: true } },
  constructionSiteSubmissions: {
    select: {
      participant: {
        select: {
          society: {
            select: {
              siren: true,
              denomination: true,
            },
          },
        },
      },
      quoteOrFeeAgreementDetails: {
        select: {
          missionsOrActivitiesOrMaterialTypes: true,
          date: true,
          invoiceAmount: true,
          invoiceAmountAlreadyPaid: true
        },
      }
    }
  }
} satisfies Prisma.FileSelect;

export const documentTypeLabels = {
	KBIS: "KBIS",
	PIECE_IDENTITE: "Pièce d'identité",
	PLANS: "Plans",
	DECLARATION_OUVERTURE_CHANTIER: "Déclaration d'ouverture de chantier",
	ATTESTATION_DEMARRAGE: "Attestation de démarrage",
	PERMIS_CONSTRUIRE: "Permis de construire",
	DECLARATION_PREALABLE: "Déclaration préalable",
	PLANNING_TRAVAUX: "Planning des travaux",
	DECLARATION_ACHEVEMENT_TRAVAUX: "Déclaration d'achèvement des travaux",
	CONVENTION_HONORAIRES: "Convention d'honoraires",
	ATTESTATION_DECENNALE: "Attestation décennale",
	FACTURE: "Facture",
	RAPPORT_ETUDE_TECHNIQUE: "Rapport d'étude technique",
	RAPPORT_GEOTECHNIQUE: "Rapport géotechnique",
	RAPPORT_INITIAL_CONTROLE_TECHNIQUE: "Rapport initial de contrôle technique",
	RAPPORT_FINAL_CONTROLE_TECHNIQUE: "Rapport final de contrôle technique",
	DEVIS: "Devis",
	PV_RECEPTION: "PV de réception",
	LEVEE_RESERVES_PV_RECEPTION: "Levée des réserves",
	REFERE_PREVENTIF_POUR_AVOISINANTS: "Référentiel préventif pour les avoisinants",
	CONSTAT_HUISSIER_POUR_EXISTANTS: "Constat d'huissier pour les existants",
	CONTRAT_RESERVATION_BAILLEUR_SOCIAL: "Contrat de réservation du bailleur social",
	INDICATION_TARIFAIRE: "Indication tarifaire",
	NOTICE_DESCRIPTIVE: "Notice descriptive",
	OTHER: "Autre",
} as const;

/**
 * Règles du mapping :
 * - Pour les labels de champs imbriqués dans un objet, mettre le chemin à 1 niveau de profondeur : parent.child: label
 * - Sauf si l'objet est dans un tableau, dans ce cas, ne mettre que le nom du champ enfant : child: label
 */
export const metadataKeyToLabelMap: Record<string, string> = {
  siren: 'SIREN',
  immatriculation_date: 'Date kbis',
  managers: 'Nom, prénom gérants',
  surname: 'Nom',
  names: 'Prénoms',
  birth_date: 'Date de naissance',
  buildings_number: 'Nombre de bâtiments',
  floors_number: 'Nombre d\'étages maximum',
  basements_number: 'Nombre de sous-sol maximum',
  architect: 'Architecte',
  architect_name: 'Dénomination sociale',
  architect_siren: 'SIREN',
  project_owner: 'MOA',
  project_owner_name: 'MOA : Dénomination sociale',
  project_owner_siren: 'MOA : SIREN',
  'project_owner.name': 'Prénom',
  'project_owner.surname': 'Nom',
  'project_owner.company': 'Dénomination sociale',
  planning_permission_number: 'Numéro de PC',
  company_name: 'Dénomination sociale',
  siret: 'SIRET',
  name: 'Prénom',
  opening_date: 'Date d\'ouverture du chantier',
  surface_area: 'Surface créée',
  city_hall_stamp: 'Tampon Mairie',
  ending_date: 'Date d\'achèvement des travaux',
  planning_permission_type: 'Type PC',
  operation_description: 'Descriptif de l\'opération',
  postal_address: 'Adresse de l\'opération',
  prior_declaration_number: 'Numéro de la DP',
  starting_date: 'Date de début de travaux',
  amount_before_tax: 'Honoraires HT',
  amount_after_tax: 'Honoraires TTC',
  missions: 'Missions',
  activities: 'Activités',
  report_date: 'Date du rapport',
  conclusion: 'Synthèse / Préconisations',
  unfavorable_notice_number: 'Avis défavorables - nombre',
  unfavorable_notice_description: 'Avis défavorables - description',
  suspended_notice_number: 'Avis suspendus - nombre',
  suspended_notice_description: 'Avis suspendus - description',
  date: 'Date',
  total_amount: 'Montant de la facture',
  paid_amount: 'Montant déjà réglé',
  material_type: 'Type de matériaux',
  total_amount_before_tax: 'Devis HT',
  total_amount_after_tax: 'Devis TTC',
  reception_date: 'Date de réception',
  reservations: 'Réserves à la réception',
  reservations_details: 'Détail des réserves',
  signed: 'PV signé',
  stamped: 'Tamponné',
  insurer_siren: 'Assureur - SIREN',
  insurer_name: 'Assureur - Dénomination sociale',
  insured_firm_siren: 'SIREN',
  insured_firm_name: 'Dénomination sociale',
  validity_start_date: 'Date de début de validité',
  validity_end_date: 'Date de fin de validité',
  main_activities: 'Activités principales couvertes',
  additional_activities: 'Activités secondaires et complémentaires couvertes',
  excluded_activities: 'Activités exclues',
  moaFirstName: 'Prénom MOA',
  moaLastName: 'Nom MOA',
  feesHT: 'Montant HT',
  feesTTC: 'Montant TTC',
  missionsOrActivitiesSelected: 'Activités',
  materialTypes: 'Type de matériaux',
  invoiceAmount: 'Montant de la facture',
  invoiceAmountAlreadyPaid: 'Montant déjà réglé',
};

export const fileTypeAndIssuerMapping: Record<DocumentType, { label: string; schema: Record<string, unknown> } | Partial<Record<IssuerType, { label: string; schema: Record<string, unknown> }>>> = {
  KBIS: {
    GENERALITES: {
      label: "KBIS",
      schema:{
        siren: "",
        immatriculation_date: "",
        managers: [{ surname: "", names: "" }],
      }
    },
  },
  PIECE_IDENTITE: {
    GENERALITES: {
      label: "Pièce d'identité",
      schema: {
        surname: "",
        names: "",
        birth_date: "",
      }
    },
  },
  PLANS: {
    GENERALITES: {
      label: "Plans",
      schema: {
        buildings_number: "",
        floors_number: "",
        basements_number: "",
        architect: false,
        architect_name: "",
        architect_siren: 0,
        project_owner: false,
        project_owner_name: "",
        project_owner_siren: 0,
      }
    }
  },
  DECLARATION_OUVERTURE_CHANTIER: {
    GENERALITES: {
      label: "Déclaration d'ouverture de chantier",
      schema: {
        planning_permission_number: "",
        company_name: "",
        siret: "",
        name: "",
        surname: "",
        opening_date: "",
        surface_area: "",
        city_hall_stamp: false,
      }
    },
  },
  ATTESTATION_DEMARRAGE: {
    GENERALITES: {
      label: "Attestation de démarrage",
      schema: {
        company_name: "",
        siret: "",
        name: "",
        surname: "",
        opening_date: "",
      }
    },
  },
  PERMIS_CONSTRUIRE: {
    GENERALITES: {
      label: "Permis de construire",
      schema: {
        planning_permission_number: "",
        planning_permission_type: "",
        operation_description: "",
        postal_address: "",
        surface_area: "",
      }
    },
  },
  DECLARATION_PREALABLE: {
    GENERALITES: {
      label: "Déclaration préalable",
      schema: {
        prior_declaration_number: "",
        operation_description: "",
        postal_address: "",
        surface_area: "",
      }
    },
  },
  PLANNING_TRAVAUX: {
    GENERALITES: {
      label: "Planning des travaux",
      schema: {
        starting_date: "",
        ending_date: "",
      }
    },
  },
  DECLARATION_ACHEVEMENT_TRAVAUX: {
    GENERALITES: {
      label: "Déclaration d'achèvement de travaux",
      schema: {
        planning_permission_number: "",
        company_name: "",
        siret: "",
        name: "",
        surname: "",
        ending_date: "",
        city_hall_stamp: false,
      }
    },
  },
  CONVENTION_HONORAIRES: {
    BUREAU_ETUDE: {
      label: "Convention honoraires - Bureau d'étude",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        missions: [],
        amount_before_tax: "",
        amount_after_tax: "",
      }
    },
    CONTROLEUR_TECHNIQUE: {
      label: "Convention honoraires - Contrôleur technique",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        missions: [],
        amount_before_tax: "",
        amount_after_tax: "",
      }
    },
    GEOTECHNICIEN: {
      label: "Convention honoraires - Géotechnicien",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        missions: [],
        amount_before_tax: "",
        amount_after_tax: "",
      }
    },
    MAITRE_OEUVRE: {
      label: "Convention honoraires - Maitre d'oeuvre",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        missions: [],
        amount_before_tax: "",
        amount_after_tax: "",
      }
    },
    ARCHITECTE: {
      label: "Convention honoraires - Architecte",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        missions: [],
        amount_before_tax: "",
        amount_after_tax: "",
      }
    },
  },
  DEVIS: {
    REALISATEUR: {
      label: "Devis - Réalisateur",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        activities: [],
        total_amount_before_tax: "",
        total_amount_after_tax: "",
      }
    },
    MATERIAUX: {
      label: "Devis - Matériaux",
      schema: {
        project_owner: { name: "", surname: "", company: "" },
        material_type: [],
        date: "",
        total_amount_before_tax: "",
        total_amount_after_tax: "",
      }
    },
  },
  FACTURE: {
    MAITRE_OEUVRE: {
      label: "Facture - Maitre d'oeuvre",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        date: "",
        total_amount: "",
        paid_amount: "",
      }
    },
    ARCHITECTE: {
      label: "Facture - Architecte",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        date: "",
        total_amount: "",
        paid_amount: "",
      }
    },
    CONTROLEUR_TECHNIQUE: {
      label: "Facture - Contrôleur technique",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        date: "",
        total_amount: "",
        paid_amount: "",
      }
    },
    BUREAU_ETUDE: {
      label: "Facture - Bureau d'étude",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        date: "",
        total_amount: "",
        paid_amount: "",
      }
    },
    GEOTECHNICIEN: {
      label: "Facture - Géotechnicien",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        date: "",
        total_amount: "",
        paid_amount: "",
      }
    },
    REALISATEUR: {
      label: "Facture - Réalisateur",
      schema: {
        siren: "",
        company_name: "",
        project_owner: { name: "", surname: "", company: "" },
        date: "",
        total_amount: "",
        paid_amount: "",
      }
    },
    MATERIAUX: {
      label: "Facture - Matériaux",
      schema: {
        material_type: [],
        date: "",
        total_amount: "",
        paid_amount: "",
      }
    },
  },
  PV_RECEPTION: {
    REALISATEUR: {
      label: "PV de réception",
      schema: {
        siren: "",
        company_name: "",
        reception_date: "",
        reservations: false,
        reservations_details: "",
        signed: false,
        stamped: false,
      }
    },
  },
  RAPPORT_ETUDE_TECHNIQUE: {
    BUREAU_ETUDE: {
      label: "Rapport d'étude technique",
      schema: {
        siren: "",
        company_name: "",
        report_date: "",
        conclusion: "",
      }
    },
  },
  RAPPORT_GEOTECHNIQUE: {
    GEOTECHNICIEN: {
      label: "Rapport géotechnique",
      schema: {
        siren: "",
        company_name: "",
        report_date: "",
        mission: "",
        conclusion: "",
      }
    },
  },
  RAPPORT_INITIAL_CONTROLE_TECHNIQUE: {
    CONTROLEUR_TECHNIQUE: {
      label: "Rapport initial de contrôle technique",
      schema: {
        siren: "",
        company_name: "",
        missions: [],
        unfavorable_notice_number: 0,
        unfavorable_notice_description: [],
        suspended_notice_number: 0,
        suspended_notice_description: [],
        date: "",
        conclusion: "",
      }
    },
  },
  RAPPORT_FINAL_CONTROLE_TECHNIQUE: {
    CONTROLEUR_TECHNIQUE: {
      label: "Rapport final de contrôle technique",
      schema: {
        siren: "",
        company_name: "",
        unfavorable_notice_number: 0,
        unfavorable_notice_description: [],
        suspended_notice_number: 0,
        suspended_notice_description: [],
        date: "",
        conclusion: "",
      }
    },
  },
  ATTESTATION_DECENNALE: {
    BUREAU_ETUDE: {
      label: "Attestation décennale - Bureau d'étude",
      schema: {
        insurer_siren: "",
        insurer_name: "",
        insured_firm_siren: "",
        insured_firm_name: "",
        validity_start_date: "",
        validity_end_date: "",
        missions: [],
      }
    },
    GEOTECHNICIEN: {
      label: "Attestation décennale - Géotechnicien",
      schema: {
        insurer_siren: "",
        insurer_name: "",
        insured_firm_siren: "",
        insured_firm_name: "",
        validity_start_date: "",
        validity_end_date: "",
        missions: [],
      }
    },
    CONTROLEUR_TECHNIQUE: {
      label: "Attestation décennale - Contrôleur technique",
      schema: {
        insurer_siren: "",
        insurer_name: "",
        insured_firm_siren: "",
        insured_firm_name: "",
        validity_start_date: "",
        validity_end_date: "",
        missions: [],
      }
    },
    REALISATEUR: {
      label: "Attestation décennale - Réalisateur",
      schema: {
        insurer_siren: "",
        insurer_name: "",
        insured_firm_siren: "",
        insured_firm_name: "",
        validity_start_date: "",
        validity_end_date: "",
        main_activities: [],
        additional_activities: [],
        excluded_activities: [],
      }
    },
    MAITRE_OEUVRE: {
      label: "Attestation décennale - Maitre d'oeuvre",
      schema: {
        insurer_siren: "",
        insurer_name: "",
        insured_firm_siren: "",
        insured_firm_name: "",
        validity_start_date: "",
        validity_end_date: "",
        missions: [],
      }
    },
    ARCHITECTE: {
      label: "Attestation décennale - Architecte",
      schema: {
        insurer_siren: "",
        insurer_name: "",
        insured_firm_siren: "",
        insured_firm_name: "",
        validity_start_date: "",
        validity_end_date: "",
        missions: [],
      }
    },
  },
  REFERE_PREVENTIF_POUR_AVOISINANTS: {
    label: "Référentiel préventif pour les avoisinants",
    schema: {},
  },
  CONSTAT_HUISSIER_POUR_EXISTANTS: {
    label: "Constat d'huissier pour les existants",
    schema: {},
  },
  CONTRAT_RESERVATION_BAILLEUR_SOCIAL: {
    label: "Contrat de réservation du bailleur social",
    schema: {},
  },
  INDICATION_TARIFAIRE: {
    GENERALITES: {
      label: "Indication tarifaire",
      schema: {},
    },
  },
  OTHER: {
    GENERALITES: {
      label: "Autre",
      schema: {},
    },
  },
  NOTICE_DESCRIPTIVE: {
    GENERALITES: {
      label: "Notice descriptive",
      schema: {},
    },
  },
   LEVEE_RESERVES_PV_RECEPTION: {
    REALISATEUR: {
      label: "Levée des réserves du PV de réception",
      schema: {}
    },
  },
};
